const MOBILE_BREAKPOINT = 768

export function isMobile() {
  return window.innerWidth <= MOBILE_BREAKPOINT
}

export function activeSidebar() {
  const mode = document.body.dataset.sidebarModeActiveValue || "main"
  return document.querySelector(`.gl-sidebar.main-sidebar.gl-sidebar--mode-${mode}`)
    || document.querySelector(".gl-sidebar.main-sidebar.show")
    || document.querySelector(".gl-sidebar.main-sidebar")
    || document.querySelector(".gl-sidebar")
}

export function isDrillOpen() {
  const sidebar = activeSidebar()
  return sidebar?.classList.contains("drilling") ?? false
}

export function closeDrillPanel() {
  const sidebar = activeSidebar()
  if (!sidebar) return

  const panel = sidebar.querySelector(".gl-sidebar-drill-panel")
  if (panel) panel.classList.remove("open")
  sidebar.classList.remove("drilling")

  sidebar.querySelectorAll(".gl-sidebar-group.open").forEach(g => {
    g.classList.remove("open")
    const t = g.querySelector("[aria-expanded]")
    if (t) t.setAttribute("aria-expanded", "false")
  })

}

export function openDrillPanel(sidebar, title, sourceContainer, skipSelector) {
  if (isDrillOpen()) closeDrillPanel()

  const panel = getOrCreateDrillPanel(sidebar)
  const itemsContainer = panel.querySelector(".gl-sidebar-drill-items")
  const titleEl = panel.querySelector(".gl-sidebar-drill-title")

  itemsContainer.innerHTML = ""
  titleEl.textContent = title

  Array.from(sourceContainer.children).forEach(child => {
    if (skipSelector && child.matches(skipSelector)) return
    const clone = child.cloneNode(true)
    clone.style.cssText = ""
    itemsContainer.appendChild(clone)
  })

  sidebar.classList.add("drilling")
  requestAnimationFrame(() => panel.classList.add("open"))
}

export function removeDrillPanel() {
  const sidebar = activeSidebar()
  if (!sidebar) return
  sidebar.classList.remove("drilling")
  const panel = sidebar.querySelector(".gl-sidebar-drill-panel")
  if (panel) panel.remove()
}

function getOrCreateDrillPanel(sidebar) {
  let panel = sidebar.querySelector(".gl-sidebar-drill-panel")
  if (panel) return panel

  panel = document.createElement("div")
  panel.className = "gl-sidebar-drill-panel"

  const header = document.createElement("div")
  header.className = "gl-sidebar-drill-header"

  const backBtn = document.createElement("button")
  backBtn.className = "gl-sidebar-drill-back"
  backBtn.type = "button"
  backBtn.setAttribute("aria-label", "Back")
  backBtn.innerHTML = '<i class="ph ph-caret-left"></i>'
  backBtn.addEventListener("click", closeDrillPanel)

  const titleEl = document.createElement("span")
  titleEl.className = "gl-sidebar-drill-title"

  header.appendChild(backBtn)
  header.appendChild(titleEl)

  const items = document.createElement("div")
  items.className = "gl-sidebar-drill-items"

  panel.appendChild(header)
  panel.appendChild(items)
  sidebar.appendChild(panel)

  return panel
}
